var React = require('react');

function MarketLead (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.093 12H6v1.5H2.63l-.615 2h5.735V14h1.5v1.5h5.734l-.615-2H11V12h2.908l-.461-1.5H12V9h2c.329 0 .62.215.716.53l2 6.5a.75.75 0 0 1-.716.97H1a.75.75 0 0 1-.717-.97l2-6.5A.75.75 0 0 1 3 9h2v1.5H3.554L3.093 12zM8.5 0a4.5 4.5 0 0 1 4.316 5.777C12.143 8.116 9.777 9.57 8.5 12.5 7.223 9.57 4.858 8.116 4.184 5.777A4.501 4.501 0 0 1 8.5 0zm0 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z","fill":"#000","fillRule":"evenodd"}));
}

MarketLead.defaultProps = {"width":"17","height":"17"};

module.exports = MarketLead;

MarketLead.default = MarketLead;
